import React, { useEffect } from "react";

/* The lookups hand back small art — 200px from TCGplayer, a card-sized scan
   from the One Piece CDN. Enough to recognise a card, not enough to check one.
   TCGplayer serves the same product at 1000px under a size in the filename, so
   ask for that when the URL carries one and fall back to what we were given. */
export function largeImage(url) {
  if (!url) return "";
  /* tcgdex publishes each card at two sizes under the same path, and the
     search deliberately asks for the small one — it is loading dozens at a
     time and 18KB against 85KB is the difference. Enlarging is the one moment
     the big one is worth fetching. */
  if (/\/low\.(webp|png|jpg)$/i.test(url)) return url.replace(/\/low\.(\w+)$/i, "/high.$1");
  return url.replace(/_in_\d+x\d+(\.\w+)$/, "_in_1000x1000$1");
}

/**
 * Full-size card art over a scrim. Closes on Escape, on the backdrop, and on
 * its own button.
 *
 * @param card  { name, imageUrl, setName|set, number }
 * @param onClose
 */
export default function CardZoom({ card, onClose }) {
  useEffect(() => {
    if (!card) return undefined;
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [card, onClose]);

  if (!card) return null;
  const set = card.setName || card.set || "";

  return (
    <div
      className="card-zoom"
      role="dialog"
      aria-modal="true"
      aria-label={`${card.name}, enlarged`}
      onClick={onClose}
    >
      {/* Only the backdrop dismisses — clicking the card itself shouldn't. */}
      <div className="card-zoom-panel" onClick={(e) => e.stopPropagation()}>
        <img className="card-zoom-img" src={largeImage(card.imageUrl)} alt={card.name} />
        <div className="card-zoom-meta">
          <div>
            <div className="card-zoom-name">{card.name}</div>
            {(set || card.number) && (
              <div className="card-zoom-set">
                {set}{set && card.number ? " · " : ""}{card.number}
              </div>
            )}
          </div>
          <button className="btn btn-secondary btn-sm" autoFocus onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
